import { INIT_SPACE_CREATION, SPACE_CREATION_ERROR, SPACE_CREATION_SUCCESS } from './action-types';
import axios from 'axios';

export function createSpaceWithForm(form_input) {
  console.log(form_input)
  console.log("test create")
  return (dispatch, getState) => {
    const { auth } = getState();
    auth.user.getIdToken().then(function(token) {
      axios.defaults.headers.common['Authorization'] = token;
      axios.post('https://tinbin.herokuapp.com/spaces', form_input)
      .then(result => dispatch(createSpaceSuccessful(result)))
      .catch(error =>
      dispatch(createSpaceError(error)));
    }).catch(error =>
    dispatch(createSpaceError(error)));
  };
}

export function createSpaceSuccessful(space) {
  console.log(space)
  return {
    type: SPACE_CREATION_SUCCESS,
    payload: space
  };
}

export function createSpaceError(error) {
  console.log(error)
  return {
    type: SPACE_CREATION_ERROR,
    payload: error
  };
}



// WEBPACK FOOTER //
// ./src/create-space/actions.js